<template>
    <v-toolbar app>
        <v-toolbar-side-icon @click="$emit('icon-click')"></v-toolbar-side-icon>
        <v-toolbar-title>{{title}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
            <slot name="toolbar-items"></slot>
        </v-toolbar-items>
        <v-btn depressed :to="'/logout'">Sign Out</v-btn>
  </v-toolbar>
</template>

<script>
    export default {
        props: {
            title: {
                type: String
            },
            items: {
                type: Array
            }
        },
    }
</script>

<style scoped>

</style>